import { createGlobalStyle } from "styled-components"
import { theme } from "./theme"

const GlobalStyle = createGlobalStyle`
	html {
		font-size: 18px;
		
	}
	body {
		line-height: 1.6;
		font-family: 'Roboto', sans-serif;
		background-color: ${theme.background};
		color: ${theme.text};
		margin: auto;
		min-height: 100vh;
	}
	ul, p, a {
		font-size: .8rem;
		@media screen and (min-width: 768px){
			font-size: .8rem;
		}
	}
	p {
		margin-bottom: .7rem;
	}
	p:last-child {
		margin-bottom: 0;
	}
	ul {
		list-style: none;
		line-height: 1.4;
		li {
			margin-bottom: 0.4rem;
		}
	}
	main {
		max-width: 100%;
		margin: auto;
		padding: 0 0.75rem;
		@media screen and (min-width: 768px) {
			padding: 0 1.25rem;
		}
		@media screen and (min-width: 1300px) {
			max-width: 85vw;
		}
		@media screen and (min-width: 1500px) {
			max-width: 75vw;
		}
		@media screen and (min-width: 1600px) {
			max-width: 65vw;
		}
	}
	.bullet-list ul {
		transform: translateX(0.5rem);
		
		li:before {
			content: '';
			height: 4px;
			width: 4px;
			display: inline-block;
			position: absolute;
			border-radius: 50%;
			transform: translateX(-.5rem) translateY(.27rem);
			.bullet-list-red& {
				background: ${theme.primary};
			}
			.bullet-list-black& {
				background: ${theme.text};
			}
			@media screen and (min-width: 768px){
				transform: translateX(-.5rem) translateY(.4rem);
			}
		}
	}
	h1 {
		font-family: 'Fira Sans Extra Condensed', sans-serif;
		text-transform: uppercase;
		font-size: 1.4rem;
		font-weight: 500;
		line-height: 1.4rem;
		letter-spacing: 1px;
		margin-bottom: .25rem;
		@media screen and (min-width: 768px) {
			font-size: 2rem;
			line-height: 2rem;
			letter-spacing: 2px;
			font-weight: 700;
		}
	}
	h2 {
		font-family: 'Fira Sans Extra Condensed', sans-serif;
		text-transform: uppercase;
	}
	h3 {
		font-size: 1.25rem;
		letter-spacing: 1px;
		font-weight: 300;
	}
	h4 {
		text-transform: uppercase;
		font-size: .6rem;
		font-weight: 700;
	}
	img {
		object-fit: cover;
	}
	.ReactCollapse--collapse {
 		transition: height 300ms;
	}

	.slick-prev:before, .slick-next:before {
		color: transparent !important;
	}
	
`

export default GlobalStyle
